import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Apollo } from 'apollo-angular'
import {
    RegisterNewsLetterSubscriptionMutation,
    RegisterNewsLetterSubscriptionMutationService,
    RegisterNewsLetterSubscriptionMutationVariables,
} from '@app-graphql/schema'

@Injectable({
    providedIn: 'root',
})
export class NewsLetterService {

    constructor(
        private readonly registerNewsLetterSubscriptionMutationService: RegisterNewsLetterSubscriptionMutationService,
    ) { }

    public registerForNewsLetter(input: RegisterNewsLetterSubscriptionMutationVariables)
        : Observable<Apollo.MutateResult<RegisterNewsLetterSubscriptionMutation>> {
        return this.registerNewsLetterSubscriptionMutationService.mutate({
            variables: input,
            errorPolicy: 'all',
        })
    }
}
